<template>
  <div class="row align-items-baseline">
    <router-link
      :to="{ name: 'finishedAuctionsCatalog', query: { dzielo: artwork.slug, page: $route.query.page || FIRST_PAGE, q: $route.query.q }}"
      tag="div"
      class="col-10"
    >
      <ArtistDetails
        v-if="artwork.artist"
        class="headings--h2"
        :artist="artwork.artist"
      />
      <div
        v-else
        class="headings--h2"
      >
        {{ artwork.name }}
      </div>
    </router-link>
    <div class="col-2 text-right">
      <ArtworkMemorise
        :artwork="artwork"
        @handleMemoriseResponse="changeArtworkMemoriseState"
      />
    </div>
    <ArtworkModal
      v-if="$route.query.dzielo === artwork.slug"
      :artwork="artwork"
      :index="index"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { FIRST_PAGE } from '@/shared/consts';
import ArtistDetails from '@/shared/components/artist_details';
import ArtworkModal from '@/shared/components/modal';
import ArtworkMemorise from '@/shared/components/artwork_memorise';

export default {
  name: 'ArtworkHeader',
  components: {
    ArtistDetails,
    ArtworkModal,
    ArtworkMemorise,
  },
  props: {
    artwork: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    ...mapMutations(['SET_MEMORISE_STATE']),
    changeArtworkMemoriseState(artworkId) {
      this.SET_MEMORISE_STATE(artworkId);
    },
  },
  created() {
    this.FIRST_PAGE = FIRST_PAGE;
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/artwork/artwork_header.vue?6ac8770f